define([ 'jquery'], function($) {
    'use strict';

function init() {
	let $webChatClientWrapper;

    $(document).ready(initIframe);

    function initIframe() {
        $webChatClientWrapper = $('#webChatClientWrapper');
        if (!$webChatClientWrapper.length) {
            window.setTimeout(initIframe,500);
            return;
        }

        let timer;
        postWebchatContainerSize(timer);
        const mutationObserver = new MutationObserver(postWebchatContainerSize);
        mutationObserver.observe($webChatClientWrapper[0], { attributes: true, subtree: true });
    }

    function postWebchatContainerSize(timer) {
        // setTimeout has been run already, delete it
        if (timer) {
            clearTimeout(timer);
        }
        // Add timout to fix issue where parent not setting web-chat-client-iframe height/width
        timer = setTimeout(() => {
            const visibleElement = $webChatClientWrapper.children(':visible');
            let height = 0;
            if (visibleElement.offset()) {
                height = $(window).height() - visibleElement.offset().top;
            }
            let width = $webChatClientWrapper.width();

            if(parent.postMessage) {
                parent.postMessage({operation: 'resizeIframe', width: width, height: height}, '*');
            }
        }, 100);
    }
}

return {
        init: init
    };
});